export default "__VITE_ASSET__DUmSfmEx__"